export default class LocationMetricNames {
    static CREATE_ATTEMPT = "LocationCreateAttempt";
    static CREATE_FAILURE ="LocationCreateFailure";
    static DELETE_ATTEMPT = "LocationDeleteAttempt";
    static DELETE_FAILURE ="LocationDeleteFailure";
}
